export const BRAND_NAME = 'PT RIKSA JAYA SWASTIKA';
export const TELEPHONE = '(0251) 20001 003';
export const MOBILE = '0822-4611-3462';
export const EMAIL = 'rjs.riksajayaswastika@gmail.com';
export const ADDRESS = 'Purimas Regency Blok A2 No. 20 RT.02/RW.07, Desa Bitungsari, Kecamatan Ciawi, Kabupaten Bogor, Jawa Barat';
export const COPYRIGHT = '2025 PT BROTHERS NETWORK SINERGI';
export const SOCIAL_MEDIA = [
    {
        name: 'instagram',
        value: 'riksajayaswastika',
        link: 'https://www.instagram.com/riksajayaswastika',
    }
]